import { styled } from "@mui/material/styles";
import { TableCell } from "@mui/material";

export const StyledTableCell = styled(TableCell)({
  fontWeight: "bold",
});
